import placeholderImage from './placeholder.avif'

export const defaultImage = placeholderImage.src
